<template>
  <a-modal
    class="company-add-wrap"
    v-bind="options"
    :closable="true"
    :footer="null"
    @ok="handleOk"
    @cancel="handleCancel">
    <div class="body-wrap">
      <Form ref="form" layoutType="grid" :optionList="formRow" :formRules="formRules" :defaultModel="defaultValue" @searchExp="searchExp"></Form>
      <div style="height:150px">
        <Table
          ref="table"
          :options="fields"
          :tableValue="tableValue"
          :customSlotOpt="slotOpt"
          :otherOpt="customOtherOpt"
          @change="handlerChange"
          @actionClick="handlerActionClick"
        ></Table>
      </div>
      
    </div>
  </a-modal>
</template>

<script>
import Form from '@/views/backstageSupport/components/formTable/form.vue'
import Table from '@/views/backstageSupport/components/table'
import { fields, formRow, formRules, slotOpt } from '../configs/modal'
import { searchCompanyInfo, asyncAddCompany } from '@/api/superViseInfos.js'
export default {
  props: {
    customOpt: Object
  },
  data() {
    return {
      fields,
      formRow,
      slotOpt,
      formRules,
      options: {
        title: '新增',
        width: 800,
        visible: false,
        loading: false,
        centered: true,
        // contentTips: '我是内容'
      },
      tableValue: [],
      defaultValue:{
        // condition: '申请人'
      },
      customOtherOpt:{
        pagination: false,
      },
      sourceOptions: { // 事件的点击来源.主要用于指向用户点击ok后的去处
        source: '', // 去处
        params: {} // 参数
      },
      radioCheckList: []  // 企业名录的勾选
    }
  },
  components: {
    Form,
    Table
  },
  watch: {
    options:{
      handler(){
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    async syncCompany(params) {
      const { radioCheckList } = this
      const { row } = params
      const formV = this.$refs.form.formModel
      const requestParams = radioCheckList.reduce((pre, cur) => {
        const { prop, status} = cur
        if(row[prop]) {
          pre[prop] = row[prop]
        }
        if(pre.patentStatus) {
          pre.patentStatus.push(status)
        } else {
          pre.patentStatus = [status]
        }
        return pre
      }, {})
      const { condition, searchExpre } = formV
      requestParams.enpName = condition
      requestParams.condition = searchExpre
      requestParams.patentCount = row.patentCount
      if(!requestParams.patentStatus) requestParams.patentStatus = [0, 1, 2]  // 默认传状态。
      const {msg, code} = await asyncAddCompany(requestParams)
      this.$apiStatusHandler(code, msg)
      this.initData() // 重置
      this.handlerVisible(false)
      this.$emit('update')
    },
    async searchExp() {
      const validate = this.$refs.form.validatedForm()
      if(!validate) return 
      const params = {...this.$refs.form.formModel}
      const v = Object.values(params).filter(item => Boolean(item))
      if(v.length < 2) {
       return this.$apiStatusHandler(999, '检索内容不能为空')
      }
      const {data} = await searchCompanyInfo(params)
      this.tableValue = [data]
      this.handlerTableMultipleRadio(data)
    },
    initData() {
      this.tableValue = []
      if(this.$refs.form) {
        this.$refs.form.initOptions()
      }
    },
    handlerTableMultipleRadio(result) {
      const t = slotOpt.find(item => item.slot === 'multipleRadio')
      t.radioList.forEach(item => {
        const {prop} = item
        if(result[prop] === undefined) return
        const v = Number(result[prop]) || 0
        item.value = v
      })
    },
    handleOk() {
      this.handlerVisible(false, this.sourceOptions)
      const form1 = this.$refs.form1.formModel
      const form2 = this.$refs.form2.formModel
      const result = Object.assign(form1, form2)
      this.$emit('ok', result)
    },
    handleCancel() {
      this.handlerVisible(false)
      this.$emit('cancel')
    },
    // 是否展示加载中的动画
    showLoading(v) {
      this.options.loading = v
    },
    // 处理弹窗是否显示
    handlerVisible(v, sourceOptions) {
      this.sourceOptions = sourceOptions
      this.options.visible = v
    },
    // 表格操作栏的点击事件
    handlerActionClick(row) {
      const { cb } = row
      // console.log(cb)
      if(this[cb]) {
        this[cb](row)
      }
    },
    // 更新已选
    radioChange(row) {
      const { checkedList } = row
      this.radioCheckList = checkedList
    },
    handlerChange() {}
  }
}
</script>
